import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const TGRadio = ({
  children,
  isChecked,
  onChange,
  disable = false,
  name = "radio",
}: {
  children: ReactNode;
  isChecked: boolean | null;
  onChange: (e: any) => void;
  disable?: boolean;
  name?: string;
}) => {
  return (
    <label className="flex items-center text-black cursor-pointer select-none">
      <div className="relative">
        <input
          name={name}
          disabled={disable}
          type="radio"
          checked={!!isChecked}
          onChange={onChange}
          className="sr-only"
        />
        <div
          className={twMerge(
            "flex items-center justify-center w-5 h-5 mr-4 border rounded-full box border-stroke",
            disable ? "border-gray3 bg-[#DFE4EA]" : "",
            !!isChecked ? "border-[#012169]" : ""
          )}
        >
          <span
            className={twMerge("h-[10px] w-[10px] rounded-full", !!isChecked ? "bg-darkblue" : "bg-transparent")}
          ></span>
        </div>
      </div>
      {children}
    </label>
  );
};

export default TGRadio;
